import gql from 'graphql-tag'

export const updateContact = ({
	contactId,
	contactData,
	contactOrganizations
}) => {
	return {
		mutation: gql`
			mutation updateSingleContact(
				$contact_id: bigint!
				$email: String!
				$name: String!
				$order: Int!
				$phone: String!
				$position: String!
				$category_id: bigint!
				$contact_organizations: [contacts_organizations_insert_input!]!
			) {
				update_contacts_by_pk(
					pk_columns: { id: $contact_id }
					_set: {
						email: $email
						name: $name
						order: $order
						phone: $phone
						position: $position
						category_id: $category_id
					}
				) {
					position
					phone
					order
					name
					email
					image_id
					category_id
				}
				delete_contacts_organizations(
					where: { contact_id: { _eq: $contact_id } }
				) {
					affected_rows
				}
				insert_contacts_organizations(objects: $contact_organizations) {
					affected_rows
				}
			}
		`,
		variables: {
			...contactData,
			contact_id: contactId,
			contact_organizations: contactOrganizations.map(org => ({
				contact_id: contactId,
				organization_id: org.id,
				active: true
			}))
		}
	}
}
